import checkoutMaterialRepository from './checkoutMaterialRepository';
import checkoutModalTypes from '@src/checkout/checkoutModalTypes';
import { t } from 'i18next';

export default class CheckoutMaterialPresenter {
  async load(callback) {
    checkoutMaterialRepository.load((pm) => {
      const details = [];
      details.push(pm.format.join(', '));
      details.push(pm.duration);

      const checkoutVm = {
        title: t(checkoutModalTypes.material.title),
        variantId: pm.variantId,
        summary: {
          product: pm.productType,
          subject: pm.subject.join(', '),
          class: pm.class,
          details: details.join(' / '),
          price: pm.price,
        },
        info: {
          productTitle: pm.title,
          author: pm.author,
          image: pm.image,
        },
      };

      callback(checkoutVm);
    });
  }

  async setCheckoutData(data) {
    checkoutMaterialRepository.updateMaterial(data);
  }
}
